const profesiones = [
    {"value": "211110", "label": "No aplica"},
    {"value": "200000", "label": "Abogado"},
    {"value": "200001", "label": "Fiscal"},
    {"value": "200002", "label": "Juez"},
    {"value": "200003", "label": "Jurista"},
    {"value": "200004", "label": "Procurador"},
    {"value": "200005", "label": "Actor /Actriz"},
    {"value": "200009", "label": "Actuario"},
    {"value": "200010", "label": "Adiestramiento animales domésticos"},
    {"value": "200013", "label": "Administración"},
    {"value": "200014", "label": "Administrador de Empresas"},
    {"value": "200015", "label": "Empleado Administrativo"},
    {"value": "200016", "label": "Ingeniero Comercial"},
    {"value": "200017", "label": "Personal Administrativo"},
    {"value": "200018", "label": "Secretario/a"},
    {"value": "200020", "label": "Agente de cambio, bolsa"},
    {"value": "200032", "label": "Analista de sistemas"},
    {"value": "200033", "label": "Anticuario"},
    {"value": "200035", "label": "Arqueólogo"},
    {"value": "200036", "label": "Arquitecto"},
    {"value": "200037", "label": "Arquitecto de interiores"},
    {"value": "200039", "label": "Auditor"},
    {"value": "200040", "label": "Autor"},
    {"value": "200041", "label": "Editor"},
    {"value": "200042", "label": "Escritor"},
    {"value": "200043", "label": "Músico de Sinfónica"},
    {"value": "200044", "label": "Cantante"},
    {"value": "200046", "label": "Diseñador. Diseñador Gráfico"},
    {"value": "200048", "label": "Diseñador Vestuario"},
    {"value": "200049", "label": "Sastre"},
    {"value": "200050", "label": "Modista"},
    {"value": "200055", "label": "Asesor"},
    {"value": "200059", "label": "Astillero Administrativo"},
    {"value": "200062", "label": "Auto-escuela"},
    {"value": "200064", "label": "Auxiliar de dentista"},
    {"value": "200065", "label": "Auxiliar de farmacia"},
    {"value": "200066", "label": "Auxiliar médico"},
    {"value": "200070", "label": "Bailarina de ballet"},
    {"value": "200071", "label": "Bailarín de ballet"},
    {"value": "200073", "label": "Banca. Tareas administrativas"},
    {"value": "200078", "label": "Bibliotecario"},
    {"value": "200079", "label": "Biólogo"},
    {"value": "200080", "label": "Bioquímico de (ensayo, industrial, farmaceutico)"},
    {"value": "200081", "label": "Bolsa de Comercio"},
    {"value": "200085", "label": "Bombero. Tareas administrativas solamente"},
    {"value": "200088", "label": "Botánico"},
    {"value": "200099", "label": "Cerrajero"},
    {"value": "200101", "label": "Cirujano"},
    {"value": "200104", "label": "Combustible. Expendedor de combustibles (gasolina,"},
    {"value": "200108", "label": "Computación e Infomática. Ingeniero"},
    {"value": "200109", "label": "Computación e Infomática. Programador"},
    {"value": "200120", "label": "Contable"},
    {"value": "200121", "label": "Contador"},
    {"value": "200129", "label": "Decorador"},
    {"value": "200132", "label": "Dentista / odontólogo"},
    {"value": "200135", "label": "Droguero"},
    {"value": "200136", "label": "Ebanista"},
    {"value": "200137", "label": "Educador"},
    {"value": "200138", "label": "Ejecutivo de Cuentas"},
    {"value": "200152", "label": "Ferrocarriles (otra profesión relacionada)"},
    {"value": "200154", "label": "Maquinista de ferrocarril"},
    {"value": "200170", "label": "Hosteleria"},
    {"value": "200193", "label": "Ingeniería: Ingeniero civil"},
    {"value": "200221", "label": "Policía/G.Civil: Solo tareas administrativas"},
    {"value": "200233", "label": "Radiología"},
    {"value": "200251", "label": "Fisioterapeuta / Kinesiólogo"},
    {"value": "200252", "label": "Kiropráctico / Osteópata"},
    {"value": "200254", "label": "Jubilado / Pensionista"},
    {"value": "200255", "label": "Medicina General"},
    {"value": "200265", "label": "Loterias, administrador"},
    {"value": "200267", "label": "Veterinario"},
    {"value": "200269", "label": "Ayudante técnico sanitario"},
    {"value": "200270", "label": "Comadrona"},
    {"value": "200271", "label": "Clínica, auxiliar de"},
    {"value": "200272", "label": "Optico"},
    {"value": "200273", "label": "Podologo"},
    {"value": "200274", "label": "Matematico"},
    {"value": "200275", "label": "Pedagogo"},
    {"value": "200276", "label": "Profesor idiomas"},
    {"value": "200277", "label": "Inspector de educacion"},
    {"value": "200278", "label": "Puericultor"},
    {"value": "200279", "label": "Profesor de informatica"},
    {"value": "200280", "label": "Cinematografia, operador de"},
    {"value": "200281", "label": "Profesor de baile"},
    {"value": "200282", "label": "Producción-realización T.V."},
    {"value": "200286", "label": "Bingo, empleado de"},
    {"value": "200287", "label": "Profesor de gimnasia"},
    {"value": "200289", "label": "Consejero"},
    {"value": "200291", "label": "Esteticista"},
    {"value": "200292", "label": "Cárceles, director de"},
    {"value": "200294", "label": "Médico de prisiones"},
    {"value": "200295", "label": "Jardinero"},
    {"value": "200296", "label": "Chacinero"},
    {"value": "200298", "label": "Zapatero"},
    {"value": "200303", "label": "Conductor trenes en ferias"},
    {"value": "200305", "label": "Animales, criador de"},
    {"value": "200307", "label": "Cárceles, administrativo en"},
    {"value": "200309", "label": "Delineante"},
    {"value": "200310", "label": "Viverista"},
    {"value": "200315", "label": "Pescadero"},
    {"value": "200320", "label": "Ortopedico"},
    {"value": "200322", "label": "Cartero"},
    {"value": "200325", "label": "Quimico sin sustancias peligrosas"},
    {"value": "200331", "label": "Dibujante tecnico"},
    {"value": "200332", "label": "Topografo, con visita a obras"},
    {"value": "200333", "label": "Medico-medicina general"},
    {"value": "200334", "label": "Medico especialista"},
    {"value": "200335", "label": "Medico radiologo"},
    {"value": "200336", "label": "Medico, resto"},
    {"value": "200337", "label": "Medico odontologo"},
    {"value": "200338", "label": "Farmaceutico"},
    {"value": "200339", "label": "Sanitario, personal"},
    {"value": "200341", "label": "Fisioterapeuta"},
    {"value": "200346", "label": "Informatico, sin viajes"},
    {"value": "200347", "label": "Economista"},
    {"value": "200349", "label": "Notario"},
    {"value": "200350", "label": "Asesor juridico"},
    {"value": "200351", "label": "Profesor de educacion, excepto deportes"},
    {"value": "200354", "label": "Periodista sin reportajes peligrosos"},
    {"value": "200356", "label": "Fotografo en estudio"},
    {"value": "200357", "label": "Fotografo de prensa"},
    {"value": "200361", "label": "Asistente social"},
    {"value": "200362", "label": "Graduado social"},
    {"value": "200363", "label": "Publicista"},
    {"value": "200364", "label": "Relaciones publicas"},
    {"value": "200365", "label": "Directivo, sin viajes"},
    {"value": "200366", "label": "Aparejador con visita a obras"},
    {"value": "200367", "label": "Administrativo(no carceles)sin viajes"},
    {"value": "200369", "label": "Recepcionista de hotel"},
    {"value": "200370", "label": "Comerciante en local"},
    {"value": "200372", "label": "Comercio,propietario de"},
    {"value": "200373", "label": "Jefe de ventas en plaza"},
    {"value": "200374", "label": "Visitador medico"},
    {"value": "200375", "label": "Agente comercial, sin viajes"},
    {"value": "200377", "label": "Agente comercial, con viajes"},
    {"value": "200379", "label": "Agente de seguros, sin viajes"},
    {"value": "200380", "label": "Agente de seguros, con viajes"},
    {"value": "200383", "label": "Cocinero"},
    {"value": "200385", "label": "Empleada de hogar"},
    {"value": "200386", "label": "Tripulacion de vuelo"},
    {"value": "200387", "label": "Limpieza en interiores, empleado de"},
    {"value": "200388", "label": "Peluquero"},
    {"value": "200399", "label": "Guarda forestal"},
    {"value": "200410", "label": "Panadero"},
    {"value": "200412", "label": "Decorador-interiorista"},
    {"value": "200414", "label": "Calzado,industria"},
    {"value": "200417", "label": "Tornero"},
    {"value": "200418", "label": "Aire acondicionado, mecanico-montador"},
    {"value": "200423", "label": "Mantenimiento de edificios"},
    {"value": "200452", "label": "Gerente, sin viajes"},
    {"value": "200461", "label": "Almacenero"},
    {"value": "200466", "label": "Astronomo"},
    {"value": "200467", "label": "Protesico dental"},
    {"value": "200468", "label": "Arquitecto, sin visita a obras"},
    {"value": "200469", "label": "Arquitecto, con visita a obras"},
    {"value": "200470", "label": "Topografo, sin visita a obras"},
    {"value": "200471", "label": "Armador de buques"},
    {"value": "200474", "label": "Terapeuta ocupacional"},
    {"value": "200475", "label": "Masajista"},
    {"value": "200479", "label": "Informatica, analista de sistemas"},
    {"value": "200480", "label": "Asesor fiscal"},
    {"value": "200483", "label": "Procurador de los tribunales"},
    {"value": "200487", "label": "Gestor administrativo"},
    {"value": "200489", "label": "Filologo"},
    {"value": "200490", "label": "Profesor de auto-escuela"},
    {"value": "200491", "label": "Profesor de natacion"},
    {"value": "200492", "label": "Decoraciones de obra en interior"},
    {"value": "200494", "label": "Camara, operador de"},
    {"value": "200495", "label": "Musico"},
    {"value": "200497", "label": "Profesor de deportes, excepto natacion"},
    {"value": "200499", "label": "Interprete"},
    {"value": "200501", "label": "Aparejador sin visita a obras"},
    {"value": "200502", "label": "Intermediario financiero, sin viajes"},
    {"value": "200504", "label": "Telefonista"},
    {"value": "200505", "label": "Administrativo en carceles"},
    {"value": "200508", "label": "Agente propiedad inmobiliaria"},
    {"value": "200509", "label": "Modelo publicitario"},
    {"value": "200510", "label": "Fruteria, empleado de"},
    {"value": "200511", "label": "Conserje"},
    {"value": "200512", "label": "Limpieza en exteriores, empleado de"},
    {"value": "200513", "label": "Automoviles, limpieza de"},
    {"value": "200514", "label": "Lavanderia, empleado de"},
    {"value": "200516", "label": "Carceles, oficial de"},
    {"value": "200518", "label": "Guia de turismo"},
    {"value": "200519", "label": "Desinfeccion-desinsectacion"},
    {"value": "200521", "label": "Ganadero sin reses bravas"},
    {"value": "200522", "label": "Ganadero,ganado de carne y lana"},
    {"value": "200523", "label": "Medico psiquiatra"},
    {"value": "200524", "label": "Horticultor"},
    {"value": "200532", "label": "Celador"},
    {"value": "200534", "label": "Pastelero"},
    {"value": "200537", "label": "Marroquinero"},
    {"value": "200539", "label": "Fresador"},
    {"value": "200540", "label": "Aire acondicionado, fabricacion aparatos"},
    {"value": "200548", "label": "Equipos telefonicos, instalador de"},
    {"value": "200549", "label": "Cableados, fabricacion de"},
    {"value": "200551", "label": "Gas, instalacion"},
    {"value": "200552", "label": "Calefaccion, instalacion"},
    {"value": "200553", "label": "Calefaccion, mantenimiento"},
    {"value": "200557", "label": "Joyero"},
    {"value": "200558", "label": "Porcelana, fabricacion de"},
    {"value": "200562", "label": "Marinero"},
    {"value": "200572", "label": "Persianas, instalacion de"},
    {"value": "200578", "label": "Gasolina, expendedor de"},
    {"value": "200579", "label": "Extintores, instalacion y recarga"},
    {"value": "200581", "label": "Seguros sin viajes, empleado de"},
    {"value": "200582", "label": "Tecnico comercial de seguros"},
    {"value": "200583", "label": "Seguros con viajes, empleado de"},
    {"value": "200585", "label": "Perito tasador"},
    {"value": "200589", "label": "Almacen, jefe de(exclusivamente supervision)"},
    {"value": "200597", "label": "Piscinas, mantenimiento"},
    {"value": "200598", "label": "Artes graficas, empleado de"},
    {"value": "200600", "label": "Contratista de obras"},
    {"value": "200601", "label": "Construccion, control calidad"},
    {"value": "200604", "label": "Fisico, sin riesgo nuclear"},
    {"value": "200606", "label": "Meteorologo"},
    {"value": "200609", "label": "Practico de puerto"},
    {"value": "200610", "label": "Zoologo"},
    {"value": "200611", "label": "Medico forense"},
    {"value": "200618", "label": "Secretario judicial"},
    {"value": "200620", "label": "Registrador de la propiedad"},
    {"value": "200622", "label": "Sociologo"},
    {"value": "200625", "label": "Sacerdote"},
    {"value": "200626", "label": "Clerigo"},
    {"value": "200627", "label": "Pintor-artista"},
    {"value": "200628", "label": "Restaurador obras arte"},
    {"value": "200630", "label": "Representante artistico"},
    {"value": "200632", "label": "Tecnico tenis de mesa"},
    {"value": "200634", "label": "Entrenador deportivo"},
    {"value": "200641", "label": "Concejal de obras"},
    {"value": "200646", "label": "Taquillero/cajero"},
    {"value": "200649", "label": "Jefe de estacion"},
    {"value": "200650", "label": "Inspector de autobuses urbanos"},
    {"value": "200651", "label": "Ordenanza"},
    {"value": "200652", "label": "Botones"},
    {"value": "200655", "label": "Encuestador"},
    {"value": "200658", "label": "Conductor lancha paracaidismo acuatico"},
    {"value": "200665", "label": "Churreria,trabajo en"},
    {"value": "200667", "label": "Portero en fincas urbanas"},
    {"value": "200670", "label": "Limpiador de cristales"},
    {"value": "200674", "label": "Guia de montaña (con escalada)"},
    {"value": "200675", "label": "Tanatorio, empleado de"},
    {"value": "200679", "label": "Regador"},
    {"value": "200681", "label": "Anilinas, fabricacion"},
    {"value": "200692", "label": "Almazarero"},
    {"value": "200693", "label": "Aceite industrial, reciclaje"},
    {"value": "200695", "label": "Peletero"},
    {"value": "200702", "label": "Cuchillos, fabricacion"},
    {"value": "200704", "label": "Navajas, fabricacion de"},
    {"value": "200707", "label": "Frigorificos industriales,instalacion"},
    {"value": "200710", "label": "Relojes, reparacion"},
    {"value": "200711", "label": "Ortopedicos, mecanico aparatos"},
    {"value": "200720", "label": "Sonido e iluminacion, instalador de"},
    {"value": "200725", "label": "Hojalata, fabricacion"},
    {"value": "200731", "label": "Tramoyista"},
    {"value": "200734", "label": "Orfebre-platero"},
    {"value": "200741", "label": "Carton, fabricacion"},
    {"value": "200742", "label": "Papel, empleado fabrica de"},
    {"value": "200744", "label": "Cajas embalajes, fabricacion"},
    {"value": "200745", "label": "Litografo"},
    {"value": "200746", "label": "Encuadernador"},
    {"value": "200748", "label": "Musica,fabricacion instrumentos de"},
    {"value": "200749", "label": "Instrumentos musicales, afinador"},
    {"value": "200751", "label": "Juguetes,industria"},
    {"value": "200753", "label": "Taxidermista"},
    {"value": "200778", "label": "Guia de montaña (sin escalada)"},
    {"value": "200782", "label": "Enologo"},
    {"value": "200785", "label": "Equipos telegraficos, instalador de"},
    {"value": "200787", "label": "Atracciones de feria con montaje"},
    {"value": "200788", "label": "Atracciones de feria sin montaje"},
    {"value": "200789", "label": "Optica, fabricacion instrumentos"},
    {"value": "200797", "label": "Horno crematorio, operario"},
    {"value": "200799", "label": "Alcalde"},
    {"value": "201014", "label": "Empresario agrícola"},
    {"value": "201015", "label": "Jefe de proyectos de desarrollo de software"},
    {"value": "201016", "label": "Jefe de proyectos de implementa.aplic.informáticas"},
    {"value": "201017", "label": "Jefe de proyectos de lingüística informática"},
    {"value": "201018", "label": "Jefe de proyectos informáticos"},
    {"value": "201019", "label": "Parametrista de software"},
    {"value": "201020", "label": "Responsable de aplic. informáticas hospitalarias"},
    {"value": "201021", "label": "Responsable de estudios informáticos"},
    {"value": "201022", "label": "Técnico superior en informática de gestión"},
    {"value": "201023", "label": "Cuidador de animales de refugio"},
    {"value": "201024", "label": "Cuidador de animales domésticos a domicilio"},
    {"value": "201025", "label": "Cuidador de gatos"},
    {"value": "201026", "label": "Cuidador de perros"},
    {"value": "201027", "label": "Caricaturista"},
    {"value": "201028", "label": "Enmarcador"},
    {"value": "201029", "label": "Esmaltador"},
    {"value": "201030", "label": "Soplador de vidrio"},
    {"value": "201031", "label": "Fabricante de pelucas"},
    {"value": "201032", "label": "Naturalista"},
    {"value": "201033", "label": "Alquiler de vehículos"},
    {"value": "201034", "label": "Trabajador en concesionario de automóviles"},
    {"value": "201035", "label": "Trabajador en concesionario de motos"},
    {"value": "201036", "label": "Auxiliar de puericultura"},
    {"value": "201037", "label": "Camillero"},
    {"value": "201038", "label": "Empleado de hospital"},
    {"value": "201039", "label": "Enfermero"},
    {"value": "201040", "label": "Enfermero de quirófano"},
    {"value": "201041", "label": "Farmacéutico de laboratorio"},
    {"value": "201042", "label": "Matrona"},
    {"value": "201043", "label": "Puericultora"},
    {"value": "201044", "label": "Adjunto comercial bancario"},
    {"value": "201045", "label": "Analista de crédito"},
    {"value": "201046", "label": "Agente de ventas"},
    {"value": "201047", "label": "Broker"},
    {"value": "201048", "label": "Cambista"},
    {"value": "201049", "label": "Calefactor"},
    {"value": "201050", "label": "Técnico de calefacciones"},
    {"value": "201051", "label": "Fisiología"},
    {"value": "201052", "label": "Sistemática"},
    {"value": "201053", "label": "Bazar"},
    {"value": "201054", "label": "Dependiente de ferretería"},
    {"value": "201055", "label": "Consultor de asistencia en proyecto informático"},
    {"value": "201056", "label": "Consultor de dirección de cambios informáticos"},
    {"value": "201057", "label": "Consultor de organización"},
    {"value": "201058", "label": "Experto técnico informático"},
    {"value": "201059", "label": "Responsable de contratos"},
    {"value": "201060", "label": "Técnico de help desk"},
    {"value": "201061", "label": "Técnico de servicios de microinformática"},
    {"value": "201062", "label": "Técnico informático de asistencia técnica"},
    {"value": "201063", "label": "Auxiliar contable"},
    {"value": "201064", "label": "Administrativo de correos"},
    {"value": "201065", "label": "Dietista"},
    {"value": "201066", "label": "Naturópata"},
    {"value": "201067", "label": "Ortofonista"},
    {"value": "201068", "label": "Ortoptista"},
    {"value": "201069", "label": "Pedicuro"},
    {"value": "201070", "label": "Quinesiterapeuta"},
    {"value": "201071", "label": "Quiropráctico"},
    {"value": "201072", "label": "Coreógrafo"},
    {"value": "201073", "label": "Ilustrador"},
    {"value": "201074", "label": "Librero"},
    {"value": "201075", "label": "Miniaturista"},
    {"value": "201076", "label": "Restaurador de libros antiguos"},
    {"value": "201077", "label": "Director de colegio"},
    {"value": "201078", "label": "Director de instituto"},
    {"value": "201079", "label": "Chocolatero"},
    {"value": "201080", "label": "Cocinero de catering"},
    {"value": "201081", "label": "Comerciante de productos tempranos"},
    {"value": "201082", "label": "Comerciante de vinos y bebidas alcohólicas"},
    {"value": "201083", "label": "Confitero"},
    {"value": "201084", "label": "Fabricante de conservas"},
    {"value": "201085", "label": "Maestro cervecero"},
    {"value": "201086", "label": "Mantequero"},
    {"value": "201087", "label": "Productor de lácteos"},
    {"value": "201088", "label": "Quesero"},
    {"value": "201089", "label": "Vendedor de semillas"},
    {"value": "201090", "label": "Vendedor de ultramarinos"},
    {"value": "201091", "label": "Vendedor de vino y bebidas alcohólicas"},
    {"value": "201092", "label": "Analista financiero"},
    {"value": "201093", "label": "Analista financiero agrícola"},
    {"value": "201094", "label": "Asesor financiero"},
    {"value": "201095", "label": "Encargado de gestión contable"},
    {"value": "201096", "label": "Encargado de gestión financiera"},
    {"value": "201097", "label": "Gestor de activos y pasivos"},
    {"value": "201098", "label": "Gestor de carteras"},
    {"value": "201099", "label": "Responsable de elaboración de informes"},
    {"value": "201100", "label": "Responsable de gestión contable"},
    {"value": "201101", "label": "Responsable de gestión financiera"},
    {"value": "201102", "label": "Responsable de inteligencia económica"},
    {"value": "201103", "label": "Controle de los servicios de policía"},
    {"value": "201104", "label": "Informática"},
    {"value": "201105", "label": "Investigaciones administrativas"},
    {"value": "201106", "label": "Investigaciones judiciales, Policía de paisano"},
    {"value": "201107", "label": "Mantenimiento del material"},
    {"value": "201108", "label": "Policía científica y técnica"},
    {"value": "201109", "label": "sepulturero"},
    {"value": "201110", "label": "Paramédico en España"},
    {"value": "201111", "label": "Responsable, director de servicios funerarios"},
    {"value": "201112", "label": "Archivista"},
    {"value": "201113", "label": "Documentalista"},
    {"value": "201114", "label": "Aparcacoches"},
    {"value": "201115", "label": "Empresario de hotel o restaurante"},
    {"value": "201116", "label": "Mozo de equipajes"},
    {"value": "201117", "label": "Mozo de hotel"},
    {"value": "201118", "label": "Diseñador web"},
    {"value": "201119", "label": "Empresario web"},
    {"value": "201120", "label": "Técnico web"},
    {"value": "201121", "label": "Decano"},
    {"value": "201122", "label": "Director de unidad de formación e investigación"},
    {"value": "201123", "label": "Engastador"},
    {"value": "201124", "label": "Gemólogo"},
    {"value": "201125", "label": "Grabador de joyas"},
    {"value": "201126", "label": "Pulidor de joyas"},
    {"value": "201127", "label": "Restaurador de joyas"},
    {"value": "201128", "label": "Corredor de apuestas"},
    {"value": "201129", "label": "Crupier"},
    {"value": "201130", "label": "Empleado de casino"},
    {"value": "201131", "label": "Administrador judicial"},
    {"value": "201132", "label": "Agente judicial"},
    {"value": "201133", "label": "Auxiliar judicial"},
    {"value": "201134", "label": "Experto jurídico"},
    {"value": "201135", "label": "Gestor judicial, oficial judicial"},
    {"value": "201136", "label": "Mediador jurídico"},
    {"value": "201137", "label": "Pasante de notario (ayudante de notario)"},
    {"value": "201138", "label": "Síndico"},
    {"value": "201139", "label": "Revisor ortográfico"},
    {"value": "201140", "label": "Traductor"},
    {"value": "201141", "label": "Agente de servicio de limpieza"},
    {"value": "201142", "label": "Asistenta"},
    {"value": "201143", "label": "Asistente doméstico"},
    {"value": "201144", "label": "Asistente para personas dependientes"},
    {"value": "201145", "label": "Asistente para personas mayores"},
    {"value": "201146", "label": "Auxiliar de mantenimiento"},
    {"value": "201147", "label": "Gobernanta"},
    {"value": "201148", "label": "Mayordomo"},
    {"value": "201149", "label": "Propietario de lavandería"},
    {"value": "201150", "label": "Asistente publicitario"},
    {"value": "201151", "label": "Responsable de agencia"},
    {"value": "201152", "label": "Bioterapeuta"},
    {"value": "201153", "label": "Técnico de calidad"},
    {"value": "201154", "label": "Ingeniero de minas"},
    {"value": "201155", "label": "Estilista de moda"},
    {"value": "201156", "label": "Acompañante musical"},
    {"value": "201157", "label": "Director de coral"},
    {"value": "201158", "label": "Director de orquesta"},
    {"value": "201159", "label": "Ingeniero de sonido"},
    {"value": "201160", "label": "Libretista"},
    {"value": "201161", "label": "Lutier"},
    {"value": "201162", "label": "Productor de música"},
    {"value": "201163", "label": "Profesor de canto"},
    {"value": "201164", "label": "Profesor de música"},
    {"value": "201165", "label": "Reparador de instrumentos de música"},
    {"value": "201166", "label": "Sonorizador"},
    {"value": "201167", "label": "Vendedor de discos"},
    {"value": "201168", "label": "Asistente materna"},
    {"value": "201169", "label": "Auxiliar de guardería"},
    {"value": "201170", "label": "Niñera"},
    {"value": "201171", "label": "Técnico de guardería"},
    {"value": "201172", "label": "Técnico en guardería"},
    {"value": "201173", "label": "Administrador de fincas"},
    {"value": "201174", "label": "Gestor de bienes"},
    {"value": "201175", "label": "Gestor de fortunas"},
    {"value": "201176", "label": "Gestor de patrimonio"},
    {"value": "201177", "label": "Azafata de tierra"},
    {"value": "201178", "label": "Director de obras públicas"},
    {"value": "201179", "label": "Ingeniero de obras públicas"},
    {"value": "201180", "label": "Ingeniero de perforación de obras públicas"},
    {"value": "201181", "label": "Jefe de obras públicas"},
    {"value": "201182", "label": "Técnico de obras públicas"},
    {"value": "201183", "label": "Inspector de pesca"},
    {"value": "201184", "label": "Analista de explotación"},
    {"value": "201185", "label": "Experto de explotación"},
    {"value": "201186", "label": "Experto en métodos de calidad"},
    {"value": "201187", "label": "Gestor de producción"},
    {"value": "201188", "label": "Integrador de explotación"},
    {"value": "201189", "label": "Responsable de explotación"},
    {"value": "201190", "label": "Técnico de explotación"},
    {"value": "201191", "label": "Ajustador"},
    {"value": "201192", "label": "Ejecutivo de confección de vestido"},
    {"value": "201193", "label": "Televendedor"},
    {"value": "201194", "label": "Mecánico dental"},
    {"value": "201195", "label": "Protésico ortopedista"},
    {"value": "201196", "label": "Técnico en aparatos auditivos"},
    {"value": "201197", "label": "Técnico en lentes"},
    {"value": "201198", "label": "Arteterapeuta"},
    {"value": "201199", "label": "Ergoterapeuta"},
    {"value": "201200", "label": "Especialista en psicomotricidad"},
    {"value": "201201", "label": "Musicoterapeuta"},
    {"value": "201202", "label": "Psicoanalista"},
    {"value": "201203", "label": "Psicopatólogo"},
    {"value": "201204", "label": "Psicoterapeuta"},
    {"value": "201205", "label": "Dueño de un café"},
    {"value": "201206", "label": "Empresario de cafetería o bar"},
    {"value": "201207", "label": "Empresario de restaurante"},
    {"value": "201208", "label": "Jefe de cocina"},
    {"value": "201209", "label": "Jefe de mesa"},
    {"value": "201210", "label": "Maître"},
    {"value": "201211", "label": "Pinche de cocina"},
    {"value": "201212", "label": "Sumiller"},
    {"value": "201213", "label": "Tabernero"},
    {"value": "201214", "label": "Desinfectador de edificios"},
    {"value": "201215", "label": "Desratizador"},
    {"value": "201216", "label": "Mecanógrafa"},
    {"value": "201217", "label": "Taquimecanógrafa, Taquimecanógrafo"},
    {"value": "201218", "label": "Guardafaros"},
    {"value": "201219", "label": "Experto en seguridad de sistemas informáticos"},
    {"value": "201220", "label": "Explotador de sistemas informáticos y redes"},
    {"value": "201221", "label": "Gestor de redes telemáticas"},
    {"value": "201222", "label": "Informático de mantenimiento"},
    {"value": "201223", "label": "Informático de mantenimiento de redes"},
    {"value": "201224", "label": "Informático técnico"},
    {"value": "201225", "label": "Ingeniero de seguridad"},
    {"value": "201226", "label": "Operador informático"},
    {"value": "201227", "label": "Responsable de seguridad informática"},
    {"value": "201228", "label": "Diseñador de productos de seguro"},
    {"value": "201229", "label": "Gestor de activos"},
    {"value": "201230", "label": "Gestor de siniestros"},
    {"value": "201231", "label": "Redactor de contenciosos"},
    {"value": "201232", "label": "Redactor de riesgos simples"},
    {"value": "201233", "label": "Redactor de siniestros"},
    {"value": "201234", "label": "Responsable de indemnizaciones"},
    {"value": "201235", "label": "Suscriptor"},
    {"value": "201236", "label": "Tarificador de riesgos agravados"},
    {"value": "201237", "label": "Técnico de actuariado"},
    {"value": "201238", "label": "Barbero"},
    {"value": "201239", "label": "Corredor de fincas"},
    {"value": "201240", "label": "Encargado de gasolinera"},
    {"value": "201241", "label": "Instalador de alarmas"},
    {"value": "201242", "label": "Propietario de Estacionamiento"},
    {"value": "201243", "label": "Propietario de gasolinera"},
    {"value": "201244", "label": "Vendedor de prensa"},
    {"value": "201245", "label": "Experto en comunicaciones y redes"},
    {"value": "201246", "label": "Experto en sistemas y redes"},
    {"value": "201247", "label": "Informático técnico superior"},
    {"value": "201248", "label": "Responsable de micro y de redes"},
    {"value": "201249", "label": "Responsable de proyecto de arquitectura"},
    {"value": "201250", "label": "Técnico en micro, redes, mensajería"},
    {"value": "201251", "label": "Técnico en redes informáticas"},
    {"value": "201252", "label": "Urbanista de sistemas de información"},
    {"value": "201253", "label": "Animador de espectáculos"},
    {"value": "201254", "label": "Asesor artístico"},
    {"value": "201255", "label": "Decorador de cine o teatro"},
    {"value": "201256", "label": "Director de cine, Director de teatro"},
    {"value": "201257", "label": "Doblador de voz"},
    {"value": "201258", "label": "Figurante"},
    {"value": "201259", "label": "Imitador"},
    {"value": "201260", "label": "Locutor"},
    {"value": "201261", "label": "Presentador de espectáculos"},
    {"value": "201262", "label": "Productor de radio"},
    {"value": "201263", "label": "Profesor de arte dramático"},
    {"value": "201264", "label": "Profesor de teatro"},
    {"value": "201265", "label": "Realizador de televisión o cine"},
    {"value": "201266", "label": "Ventrílocuo"},
    {"value": "201267", "label": "Director de iluminación"},
    {"value": "201268", "label": "Director de sonido"},
    {"value": "201269", "label": "Electricista de espectáculos"},
    {"value": "201270", "label": "Empleado de cine"},
    {"value": "201271", "label": "Empleado de teatro"},
    {"value": "201272", "label": "Empresario de cine"},
    {"value": "201273", "label": "Encargado de vestuario de cine o teatro"},
    {"value": "201274", "label": "Especialista en efectos sonoros"},
    {"value": "201275", "label": "Guionista"},
    {"value": "201276", "label": "Iluminador"},
    {"value": "201277", "label": "Maquillador de espectáculos"},
    {"value": "201278", "label": "Modista de espectáculos"},
    {"value": "201279", "label": "Montador de sonido"},
    {"value": "201280", "label": "Operador de sonido"},
    {"value": "201281", "label": "Perchman, encargado del micrófono jirafa"},
    {"value": "201282", "label": "Proyeccionista"},
    {"value": "201283", "label": "Sastre de espectáculos"},
    {"value": "201284", "label": "Utilero"},
    {"value": "201285", "label": "Técnico en radiología"},
    {"value": "201286", "label": "Ingeniero de telecomunicaciones"},
    {"value": "201287", "label": "Agente del Tesoro Público"},
    {"value": "201288", "label": "Inspector de hacienda"},
    {"value": "201289", "label": "Inspector del Tesoro"},
    {"value": "201290", "label": "Recaudador"},
    {"value": "201291", "label": "Tesorero principal"},
    {"value": "201292", "label": "Dueño de un almacén de vestido"},
    {"value": "201293", "label": "Fabricante de géneros de punto"},
    {"value": "201294", "label": "Mercería"},
    {"value": "201295", "label": "Tienda de prêt-à-porter - Venta exclusivamente"},
    {"value": "201296", "label": "Tintorero"},
    {"value": "201297", "label": "Agente administrativo"},
    {"value": "201298", "label": "Cuadro administrativo"},
    {"value": "201299", "label": "Gabarrero"},
    {"value": "201300", "label": "Obrero de navegación fluvial"},
    {"value": "201301", "label": "Oficial de navegación fluvial"},
    {"value": "201302", "label": "Piloto de navegación fluvial"},
    {"value": "201303", "label": "Transportista fluvial, empresario"},
    {"value": "201304", "label": "Conductor de funicular"},
    {"value": "201305", "label": "Guía de zoológico"},
    {"value": "201306", "label": "Mecánico de maquinaria agrícola"},
    {"value": "201307", "label": "Auxiliar sanitario"},
    {"value": "201308", "label": "Pasante de abogado, ayudante de abogado"},
    {"value": "201316", "label": "Tatuador"},
    {"value": "201317", "label": "Ingeniero aeronáutico"}
];

export default profesiones;